import type { BaseDictionaryItem } from './dictionaryUtils'

export interface AgreementTimelineTypeItem extends BaseDictionaryItem {
  inMessageBubble: boolean
  descriptor: { prepend: string; subject: string; append: string; subjectHasLink: boolean }
}

export const AGREEMENT_TIMELINE_TYPES: readonly AgreementTimelineTypeItem[] = [
  {
    key: 'agreement_created',
    label: 'Agreement Created',
    icon: 'folder-plus',
    inMessageBubble: false,
    descriptor: { prepend: 'Created the agreement', subject: '', append: '', subjectHasLink: false }
  },
  {
    key: 'agreement_imported',
    label: 'Agreement Imported',
    icon: 'folder-arrow-down',
    inMessageBubble: false,
    descriptor: {
      prepend: 'Imported the agreement',
      subject: '',
      append: '',
      subjectHasLink: false
    }
  },
  {
    key: 'note',
    label: 'Note',
    icon: 'note',
    inMessageBubble: true,
    descriptor: { prepend: 'Added a note', subject: '', append: '', subjectHasLink: false }
  },
  {
    key: 'appointment_invite',
    label: 'Appointment Invite Sent',
    icon: 'paper-plane',
    inMessageBubble: false,
    descriptor: {
      prepend: 'Generated and sent an ',
      subject: 'appointment invite',
      append: '',
      subjectHasLink: false
    }
  },
  {
    key: 'appointment_booked',
    label: 'Appointment Booked',
    icon: 'calendar',
    inMessageBubble: false,
    descriptor: { prepend: 'Booked an ', subject: 'appointment', append: '', subjectHasLink: true }
  },
  {
    key: 'appointment_rescheduled',
    label: 'Appointment Rescheduled',
    icon: 'calendar-clock',
    inMessageBubble: false,
    descriptor: {
      prepend: 'Rescheduled an ',
      subject: 'appointment',
      append: '',
      subjectHasLink: true
    }
  },
  {
    key: 'appointment_cancelled',
    label: 'Appointment Cancelled',
    icon: 'calendar-xmark',
    inMessageBubble: false,
    descriptor: {
      prepend: 'Cancelled an ',
      subject: 'appointment',
      append: '',
      subjectHasLink: true
    }
  },
  {
    key: 'appointment_assigned',
    label: 'Appointment Assigned',
    icon: 'calendar-circle-user',
    inMessageBubble: false,
    descriptor: {
      prepend: 'Assigned an ',
      subject: 'appointment',
      append: '',
      subjectHasLink: true
    }
  },
  {
    key: 'appointment_unassigned',
    label: 'Appointment Unassigned',
    icon: 'calendar-circle-user',
    inMessageBubble: false,
    descriptor: {
      prepend: 'Unassigned an ',
      subject: 'appointment',
      append: '',
      subjectHasLink: true
    }
  },
  {
    key: 'appointment_outcome_set',
    label: 'Appointment Outcome Set',
    icon: 'calendar-check',
    inMessageBubble: false,
    descriptor: {
      prepend: 'Set an ',
      subject: 'appointment ',
      append: 'outcome',
      subjectHasLink: true
    }
  },
  {
    key: 'valuation_sent',
    label: 'Valuation Sent',
    icon: 'valuation',
    inMessageBubble: false,
    descriptor: { prepend: 'Initiated a ', subject: 'valuation', append: '', subjectHasLink: true }
  },
  {
    key: 'reloop_submitted',
    label: 'Reloop Submitted',
    icon: 'reloop',
    inMessageBubble: false,
    descriptor: { prepend: 'Submitted a ', subject: 'reloop', append: '', subjectHasLink: true }
  },
  {
    key: 'contact_call',
    label: 'Called',
    icon: 'phone',
    inMessageBubble: false,
    descriptor: { prepend: 'Called', subject: '', append: '', subjectHasLink: false }
  },
  {
    key: 'contact_sms',
    label: 'SMS Sent',
    icon: 'comment',
    inMessageBubble: true,
    descriptor: { prepend: 'Sent an SMS', subject: '', append: '', subjectHasLink: false }
  },
  {
    key: 'contact_email',
    label: 'Email Sent',
    icon: 'envelope',
    inMessageBubble: false,
    descriptor: { prepend: 'Sent an email', subject: '', append: '', subjectHasLink: false }
  },
  {
    key: 'status_updated',
    label: 'Status Updated',
    icon: 'circle-dot',
    inMessageBubble: false,
    descriptor: { prepend: 'Updated the status', subject: '', append: '', subjectHasLink: false }
  },
  {
    key: 'details_updated',
    label: 'Details Updated',
    icon: 'pencil',
    inMessageBubble: false,
    descriptor: { prepend: 'Updated some details', subject: '', append: '', subjectHasLink: false }
  },
  {
    key: 'transferred_to_dealership',
    label: 'Transferred To Dealership',
    icon: 'right-left-large',
    inMessageBubble: true,
    descriptor: {
      prepend: 'Transferred to another dealership',
      subject: '',
      append: '',
      subjectHasLink: false
    }
  },
  {
    key: 'customer_archived',
    label: 'Customer Archived',
    icon: 'box-archive',
    inMessageBubble: true,
    descriptor: {
      prepend: 'Archived the agreement',
      subject: '',
      append: '',
      subjectHasLink: false
    }
  },
  {
    key: 'customer_unarchived',
    label: 'Customer Unarchived',
    icon: 'box-archive',
    inMessageBubble: false,
    descriptor: {
      prepend: 'Unarchived the agreement',
      subject: '',
      append: '',
      subjectHasLink: false
    }
  }
] as const
